import { render, staticRenderFns } from "./_userDetails.vue?vue&type=template&id=6e972343"
import script from "./_userDetails.vue?vue&type=script&lang=js"
export * from "./_userDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports